import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '8px 0'
  },
  tableWrapper: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 6,
    overflow: 'hidden'
    // height: '60vh'
  },
  tableHeader: {
    display: 'grid',
    // 7 tracks, matching the 7 header labels and the 7 cells SessionRow renders in
    // hideEmail mode -- was 8 (including a dead "Actions" label with no column
    // beneath it at all; found while fixing the analogous BL-235 mismatch on
    // AdminConfigSessions' full session table).
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr',
    alignItems: 'center',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.grey[200],
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    fontSize: 14,
    fontWeight: 500
  },
  headerText: { fontWeight: 500, fontSize: 14 },
  loadingContainer: {
    display: 'flex',
    width: '100%',
    height: '40vh',
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    display: 'grid',
    gridTemplateRows: '1fr 1fr 1fr 1fr 1fr 1fr',
    alignItems: 'center'
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 240,
    color: '#6b7280'
  },
  emptyIcon: {
    fontSize: 48,
    color: '#cbd5e1',
    marginBottom: theme.spacing(1)
  },
  emptyText: {
    fontSize: 14
  }
}))

export default useStyles
